import React from "react";
import { Button, Table } from "semantic-ui-react";
import useLinkedAlert from "../hooks/useLinkedAlert";
import useComplianceAlerts from "../hooks/useComplianceAlerts";
import ComplianceAlertTableRow from "./ComplianceAlertTableRow";
import ComplianceAlertTableHeader from "./ComplianceAlertTableHeader";

const LinkedAlerts = () => {
  const {
    selectedAlerts,
    setState,
    toggleAlert,
    toggleAllAlerts,
    confirmRemoveAlerts,
    linkedAlertData,
  } = useLinkedAlert();
  const { sortColumns } = useComplianceAlerts();

  if (!linkedAlertData || linkedAlertData.length === 0) {
    return <>None</>;
  }

  return (
    <div style={{ overflowX: "auto", width: "100%" }}>
      <Table>
        <ComplianceAlertTableHeader
          selectAllAlerts={selectedAlerts.length === linkedAlertData.length}
          handleSelectAll={() =>
            toggleAllAlerts(linkedAlertData, selectedAlerts)
          }
          sortColumns={sortColumns}
          setState={setState}
        />
        <Table.Body>
          {linkedAlertData.map((x) => (
            <ComplianceAlertTableRow
              record={x}
              selectedAlerts={selectedAlerts}
              onAlertClick={() => toggleAlert(x.id, selectedAlerts)}
              handleSelect={() => {}}
            />
          ))}
        </Table.Body>
      </Table>
      {selectedAlerts.length > 0 ? (
        <Button
          type="button"
          onClick={() => confirmRemoveAlerts(selectedAlerts, linkedAlertData)}
        >
          Remove selected alert
        </Button>
      ) : (
        <></>
      )}
    </div>
  );
};

export default LinkedAlerts;
